export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10356.320588cb.jpg";